/* =========================================================
   DEKOFAR PRODUCT SYSTEM V2
   PAINT COLOR SELECTOR

   Görev:
   - Renk kartlarını yönetir
   - Gerçek Shopify renk select'ini değiştirir
   - Mevcut paket seçimini mümkün olduğunca korur
   - Gerçek varyant kombinasyonunu bulur
   - Core variant engine'i tetikler

   Gereksinim:
   dekofar-v2-core.js önce yüklenmelidir.
========================================================= */


function dekofarV2InitColorSelectors(scope) {

  const root = scope || document;


  root
    .querySelectorAll(
      '[data-dekofar-v2-color-selector]'
    )
    .forEach((selector) => {


      /* =====================================================
         AYNI ALANI İKİ KEZ INITIALIZE ETME
      ===================================================== */

      if (
        selector.dataset.dekofarV2ColorInitialized ===
        'true'
      ) {
        return;
      }


      /* =====================================================
         PRODUCT ROOT
      ===================================================== */

      const productRoot = selector.closest(
        '.dekofar-v2-product'
      );

      if (!productRoot) {
        console.warn(
          'Dekofar V2 Color: product root bulunamadı.'
        );
        return;
      }


      /* =====================================================
         COLOR OPTION WRAPPER
      ===================================================== */

      const optionWrapper = selector.closest(
        '[data-dekofar-v2-option]'
      );

      if (!optionWrapper) {
        console.warn(
          'Dekofar V2 Color: option wrapper bulunamadı.'
        );
        return;
      }


      /* =====================================================
         GERÇEK COLOR SELECT
      ===================================================== */

      const colorSelect = optionWrapper.querySelector(
        'select[data-option-position]'
      );

      if (!colorSelect) {
        console.warn(
          'Dekofar V2 Color: gerçek renk select bulunamadı.'
        );
        return;
      }


      /* =====================================================
         COLOR OPTION POSITION
      ===================================================== */

      const colorPosition = parseInt(
        colorSelect.getAttribute(
          'data-option-position'
        ),
        10
      );

      if (
        !Number.isFinite(colorPosition) ||
        colorPosition < 1
      ) {
        console.warn(
          'Dekofar V2 Color: option position geçersiz.'
        );
        return;
      }


      const colorIndex =
        colorPosition - 1;


      /* =====================================================
         TÜM GERÇEK OPTION SELECTLERİ

         Shopify option.position sırasına göre kesin
         olarak sıralıyoruz.
      ===================================================== */

      const optionSelects = [
        ...productRoot.querySelectorAll(
          '[data-dekofar-v2-variants] select[data-option-position]'
        )
      ]
        .filter((select) => {

          const position = parseInt(
            select.getAttribute(
              'data-option-position'
            ),
            10
          );

          return (
            Number.isFinite(position) &&
            position > 0
          );

        })
        .sort((a, b) => {

          const aPosition = parseInt(
            a.getAttribute(
              'data-option-position'
            ),
            10
          );

          const bPosition = parseInt(
            b.getAttribute(
              'data-option-position'
            ),
            10
          );

          return aPosition - bPosition;

        });


      if (!optionSelects.length) {
        console.warn(
          'Dekofar V2 Color: option selectleri bulunamadı.'
        );
        return;
      }


      /* =====================================================
         PRODUCT JSON
      ===================================================== */

      if (
        typeof dekofarV2ReadProductData !==
        'function'
      ) {

        console.error(
          'Dekofar V2 Color: core.js yüklenmemiş.'
        );

        return;
      }


      const productData =
        dekofarV2ReadProductData(
          productRoot
        );


      if (
        !productData ||
        !Array.isArray(
          productData.variants
        )
      ) {

        console.error(
          'Dekofar V2 Color: product JSON bulunamadı.'
        );

        return;
      }


      /* =====================================================
         COLOR BUTTONS
      ===================================================== */

      const buttons = [
        ...selector.querySelectorAll(
          '[data-dekofar-v2-color-value]'
        )
      ];


      if (!buttons.length) {
        console.warn(
          'Dekofar V2 Color: renk kartı bulunamadı.'
        );
        return;
      }


      const selectedValueElement =
        optionWrapper.querySelector(
          '[data-dekofar-v2-color-selected-value]'
        );


      /* =====================================================
         INITIALIZED
      ===================================================== */

      selector.dataset.dekofarV2ColorInitialized =
        'true';


      /* =====================================================
         CURRENT OPTIONS

         Örnek:
         [
           "Antrasit Gri",
           "3 Kg"
         ]
      ===================================================== */

      const getCurrentOptions = () => {

        const options = [];

        optionSelects.forEach((select) => {

          const position = parseInt(
            select.getAttribute(
              'data-option-position'
            ),
            10
          );

          if (
            !Number.isFinite(position) ||
            position < 1
          ) {
            return;
          }

          options[position - 1] =
            select.value;

        });

        return options;
      };


      /* =====================================================
         FIND EXACT VARIANT
      ===================================================== */

      const findExactVariant = (options) => {

        if (
          typeof dekofarV2FindVariant ===
          'function'
        ) {

          return dekofarV2FindVariant(
            productData,
            options
          );
        }


        return (
          productData.variants.find(
            (variant) => {

              if (
                !variant ||
                !Array.isArray(
                  variant.options
                )
              ) {
                return false;
              }


              return variant.options.every(
                (optionValue, index) => {

                  return (
                    optionValue ===
                    options[index]
                  );

                }
              );

            }
          ) || null
        );
      };


      /* =====================================================
         SEÇİLEN RENK İÇİN VARYANT BUL

         Önce mevcut paket korunur.

         Örnek:
         Antrasit + 3 Kg
             ↓
         Kırmızı + 3 Kg

         Eğer Kırmızı + 3 Kg yoksa:
         Kırmızı'nın ilk stoklu varyantına geçer.
      ===================================================== */

      const findVariantForColor =
        (colorValue) => {

          const options =
            getCurrentOptions();


          options[colorIndex] =
            colorValue;


          /* Önce mevcut paketle tam kombinasyon */

          let variant =
            findExactVariant(
              options
            );


          if (
            variant &&
            variant.available
          ) {

            return variant;
          }


          /* Seçilen rengin ilk stoklu varyantı */

          variant =
            productData.variants.find(
              (candidate) => {

                return (
                  candidate &&
                  candidate.available &&
                  Array.isArray(
                    candidate.options
                  ) &&
                  candidate.options[
                    colorIndex
                  ] ===
                    colorValue
                );

              }
            ) || null;


          /* Stoklu yoksa en azından mevcut varyant */

          if (!variant) {

            variant =
              productData.variants.find(
                (candidate) => {

                  return (
                    candidate &&
                    Array.isArray(
                      candidate.options
                    ) &&
                    candidate.options[
                      colorIndex
                    ] ===
                      colorValue
                  );

                }
              ) || null;
          }


          return variant;
        };


      /* =====================================================
         SELECTLERİ GERÇEK VARYANTA UYGULA
      ===================================================== */

      const applyVariantToSelects =
        (variant) => {

          if (
            !variant ||
            !Array.isArray(
              variant.options
            )
          ) {
            return;
          }


          optionSelects.forEach(
            (select) => {

              const position = parseInt(
                select.getAttribute(
                  'data-option-position'
                ),
                10
              );


              if (
                !Number.isFinite(position) ||
                position < 1
              ) {
                return;
              }


              const optionValue =
                variant.options[
                  position - 1
                ];


              if (
                optionValue ===
                undefined ||
                optionValue ===
                null
              ) {
                return;
              }


              select.value =
                optionValue;

            }
          );
        };


      /* =====================================================
         VISUAL SELECTED STATE
      ===================================================== */

      const updateButtons =
        (value) => {


          buttons.forEach((button) => {

            const buttonValue =
              button.getAttribute(
                'data-dekofar-v2-color-value'
              );


            const isSelected =
              buttonValue ===
              value;


            button.classList.toggle(
              'is-selected',
              isSelected
            );


            button.setAttribute(
              'aria-pressed',
              isSelected
                ? 'true'
                : 'false'
            );

          });


          if (
            selectedValueElement
          ) {

            selectedValueElement.textContent =
              value;

          }

        };


      /* =====================================================
         COLOR CLICK
      ===================================================== */

      buttons.forEach((button) => {

        button.addEventListener(
          'click',
          (event) => {


            event.preventDefault();
            event.stopPropagation();


            if (
              button.disabled ||
              button.getAttribute(
                'aria-disabled'
              ) ===
                'true'
            ) {

              return;
            }


            const value =
              button.getAttribute(
                'data-dekofar-v2-color-value'
              );


            if (!value) {
              return;
            }


            /* ---------------------------------------------
               GERÇEK VARYANTI BUL
            --------------------------------------------- */

            const variant =
              findVariantForColor(
                value
              );


            if (!variant) {

              console.warn(
                'Dekofar V2 Color: renk için varyant bulunamadı:',
                value
              );

              return;
            }


            /* ---------------------------------------------
               TÜM GERÇEK SELECTLERİ SENKRONİZE ET
            --------------------------------------------- */

            applyVariantToSelects(
              variant
            );


            /* ---------------------------------------------
               UI ANINDA GÜNCELLENSİN
            --------------------------------------------- */

            updateButtons(
              value
            );


            /* ---------------------------------------------
               CORE VARIANT ENGINE

               Core renk select change event'ini dinler.
            --------------------------------------------- */

            colorSelect.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );

          }
        );

      });


      /* =====================================================
         REAL SELECT CHANGE
      ===================================================== */

      colorSelect.addEventListener(
        'change',
        () => {

          updateButtons(
            colorSelect.value
          );

        }
      );


      /* =====================================================
         GLOBAL VARIANT EVENT

         Paket tarafından veya başka bir V2 modülü
         varyantı değiştirirse renk kartı da senkron kalsın.
      ===================================================== */

      productRoot.addEventListener(
        'dekofar:v2:variant-change',
        (event) => {


          const variant =
            event.detail &&
            event.detail.variant
              ? event.detail.variant
              : null;


          if (
            !variant ||
            !Array.isArray(
              variant.options
            )
          ) {
            return;
          }


          const selectedColor =
            variant.options[
              colorIndex
            ];


          if (!selectedColor) {
            return;
          }


          colorSelect.value =
            selectedColor;


          updateButtons(
            selectedColor
          );

        }
      );


      /* =====================================================
         INITIAL STATE
      ===================================================== */

      updateButtons(
        colorSelect.value
      );

    });

}